import React from 'react';
import { MailIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/contact';
import { Eyebrow } from './Eyebrow';
export function Contact() {
  return <section aria-labelledby="contact-heading" className="bg-night-900 py-14 sm:py-20" data-id="element-79" data-mp="35ahzi3okm4wa">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-80" data-mp="318o1621ulcza">
        <Eyebrow align="center" tone="muted" data-id="element-81" data-mp="2w8s7owqs13xz">
          Kontakt
        </Eyebrow>
        <h2 id="contact-heading" className="mt-4 font-display text-3xl leading-[0.98] text-cream sm:text-5xl" data-id="element-82" data-mp="3sxzl1hh8s6qt">
          Pytania <span className="text-amber" data-id="element-83" data-mp="3oxfly8d3yt21">przed zakupem?</span>
        </h2>
        <p className="mt-4 font-serif text-lg italic leading-relaxed text-cream-soft" data-id="element-84" data-mp="3k4wc9mhjki2i">
          Napisz do nas, a odpowiemy. Odpowiadamy na każdą wiadomość dotyczącą dostępu, zawartości
          i zwrotów.
        </p>
        <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-7 inline-flex max-w-full items-center gap-3 rounded-xl border border-amber/50 bg-night-800 px-5 py-4 text-sm font-semibold text-cream transition-colors duration-150 ease-out hover:border-amber hover:text-amber sm:text-base" data-id="element-85" data-mp="ghe14q0pzkle">
          <MailIcon className="h-5 w-5 shrink-0 text-amber" aria-hidden="true" data-id="element-86" data-mp="3ou61umrexmby" />
          <span className="break-all" data-id="element-87" data-mp="3b280wz7uuwqv">{SUPPORT_EMAIL}</span>
        </a>
      </div>
    </section>;
}